



























































































































































































































import Guid from '@/app/utils/guid'
import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Evaluation from '@/evaluations/entities/evaluation'
import Score from '@/evaluations/entities/score'
import ScoreFilter from '@/evaluations/entities/score-filter'
import ratingService from '@/evaluations/services/rating-service'
import evaluationService from '@/evaluations/services/evaluation-service'
import {
  isDraft,
  isInProgress,
  isFinished,
} from '@/evaluations/utils/evaluation-states'
import ConfirmDialog from '@/common/components/confirm-dialog.vue'
import EvaluationBasicDto from '@/evaluations/models/evaluation-basic-dto'
import snacks from '@/app/services/snacks'
import Judge from '../entities/judge'
import bus from '@/app/bus'

@Component
export default class EvaluationDetails extends Vue {
  @Prop({ type: String })
  private id!: string

  @Ref()
  private startEvaluationConfirmDialog!: ConfirmDialog
  @Ref()
  private restartEvaluationConfirmDialog!: ConfirmDialog

  @Ref()
  private finishEvaluationConfirmDialog!: ConfirmDialog

  private evaluation: Evaluation = new Evaluation()

  private scoreFilter = new ScoreFilter()
  // private scores: Score[] = []
  private candidateScores: Score[] = []
  private selectedCandidates: Guid[] = []

  private loadingScores = false
  private loadingReport = false
  private loadingGuide = false
  private loadingSendGuide = false
  private loadingObservation = false
  private loadingObservationWord = false
  private changingState = false
  private loadingCandidatesReportShort = false
  private loadingCandidatesReportLong = false

  private notesSuccessMessage = ''

  private showInfo() {
    bus.$emit(
      'app.help-dialog.show',
      `
    <h2 name="evaluations-details">Evaluierungsdetails</h2>
</br>
<p>
  Die Evaluierungsdetails liefern einen Überblick über den aktuellen Stand der
  Evaluierung. Es wird der aktuelle Punktestand der Kandidat:innen angeführt,
  sowie der Fortschritt der einzelnen Assessoren bei der Bewertung. Mit Klick
  auf die Checkboxen bei den Kandidat:innen können Sie ein Spinnendiagramm für
  einen schnellen Vergleich zwischen Soll- und Istwerten der Kompetenzen
  einblenden.
</p>
<p>
  Für die einzelnen Kandidaten kann über das Lupen-Symbol eine detaillierte
  Übersicht zu den Bewertungen der Kompetenzen sowie deren Punktevergabe durch
  die Assessoren abgerufen werden.
</p>
<p>
  Unter <strong>Bewertungsfortschritt</strong> wird angezeigt, wie weit Assessoren
  beim Bewerten der Kandidat:innen sind. Mit dem Daumen hoch/runter Icon kann 
  zudem das Bewertungsformular des jeweiligen Assessors geöffnet werden. Man kann
  damit z.B. einem Assessor den Bewertungslink nochmals zur Verfügung stellen, indem
  man ihn aus der Adresszeile vom Browser rauskopiert.
</p>
<p>
  Der Interviewleitfaden ist als unterstützendes Handout für Assessoren gedacht.
  Er kann direkt als PDF heruntergeladen, oder per Knopfdruck an alle Assessoren
  versendet werden.
</p>
<p>
  Das Ergebnisprotokoll fasst sämtliche Ergebnisse der Evaluierung in einem PDF
  zusammen. Es wird beim Aufruf immer auf Basis der aktuell vorliegenden Daten
  erstellt, spiegelt also den aktuellen Stand der Evaluierung wider.
</p>`
    )
  }

  private get isDraft() {
    return isDraft(this.evaluation.status)
  }

  private get isInProgress() {
    return isInProgress(this.evaluation.status)
  }
  private get isFinished() {
    return isFinished(this.evaluation.status)
  }

  private showRadar(score: Score) {
    const result = this.selectedCandidates.filter((c) => c == score.candidateId)
    if (result.length > 0) {
      this.selectedCandidates = this.selectedCandidates.filter(
        (c) => c != score.candidateId
      )
    } else {
      this.selectedCandidates.push(score.candidateId)
    }
  }

  private showDetail(score: Score) {
    this.$router.push({
      name: 'evaluationCandidate',
      params: {
        lang: this.$i18n.locale,
        candidateId: score.candidateId,
        evaluationId: this.id,
      },
    })
  }

  private goToJudgeRatePage(judge: Judge) {
    const routeData = this.$router.resolve({
      name: 'ratinglist',
      params: {
        lang: this.$i18n.locale,
        eId: this.evaluation.id,
        jId: judge.id,
      },
    })
    window.open(routeData.href, '_blank')
  }

  private start() {
    this.startEvaluationConfirmDialog.open()
  }

  private async startConfirmed() {
    this.changingState = true
    await evaluationService.startAsync(this.id)
    await this.loadEvaluation()
    this.changingState = false
  }

  private finish() {
    this.finishEvaluationConfirmDialog.open()
  }

  private async finishConfirmed() {
    this.changingState = true
    await evaluationService.finishAsync(this.id)
    await this.loadEvaluation()
    this.changingState = false
  }

  private restart() {
    this.restartEvaluationConfirmDialog.open()
  }

  private async restartConfirmed() {
    this.changingState = true
    await evaluationService.restartAsync(this.id)
    await this.loadEvaluation()
    this.changingState = false
  }

  private async downloadFinalReport() {
    this.loadingReport = true
    var url = await evaluationService.generateReportAsync(
      this.id,
      this.selectedCandidates
    )
    if (url) {
      window.open(url)
    }
    this.loadingReport = false
  }

  private async sendInterviewGuide() {
    this.loadingSendGuide = true
    var url = await evaluationService.generateAndSendGuideAsync(this.id)
    this.loadingSendGuide = false
    snacks.success('evaluations.pages.evaluation-details.guide_sent')
  }

  private async sendObservation() {
    this.loadingObservation = true
    var url = await evaluationService.generateObservationAsync(this.id)
    if (url) {
      window.open(url)
    }
    this.loadingObservation = false
  }

  private async sendObservationWord() {
    this.loadingObservationWord = true
    var url = await evaluationService.generateObservationWordAsync(this.id)
    if (url) {
      window.open(url)
    }
    this.loadingObservationWord = false
  }

  public async downloadRadar(candidateId: string) {
    console.log('event download radar')
    var url = await evaluationService.downloadRadar(this.id, candidateId)
    if (url) {
      window.open(url)
    }
  }

  private async downloadInterviewGuide() {
    this.loadingGuide = true
    var url = await evaluationService.generateGuideAsync(this.id)
    if (url) {
      window.open(url)
    }
    this.loadingGuide = false
  }

  private async downloadCandidatesReportLong() {
    this.loadingCandidatesReportLong = true
    var url = await evaluationService.generateCandidatesReportLongAsync(
      this.id,
      this.selectedCandidates
    )
    if (url) {
      window.open(url)
    }
    this.loadingCandidatesReportLong = false
  }

  private async downloadCandidatesReportShort() {
    this.loadingCandidatesReportShort = true
    var url = await evaluationService.generateCandidatesReportShortAsync(
      this.id,
      this.selectedCandidates
    )
    if (url) {
      window.open(url)
    }
    this.loadingCandidatesReportShort = false
  }

  private async loadScores() {
    this.candidateScores = await ratingService.candidatesSummary(this.id)
    this.scoreFilter.paging.totalItems = this.candidateScores.length
  }

  private async loadEvaluation() {
    this.evaluation =
      (await evaluationService.findOneAsync(this.id)) || new Evaluation()
  }

  private async updateEvaluationNotesAsnyc() {
    const dto = new EvaluationBasicDto()
    dto.id = this.evaluation.id
    dto.remarks = this.evaluation.remarks

    await evaluationService.updateNotesAsync(dto)

    this.notesSuccessMessage = 'Gesichert'
    setTimeout(() => (this.notesSuccessMessage = ''), 1500)
  }

  private async mounted() {
    await this.loadEvaluation()
    await this.loadScores()
  }
}
